import React from "react";
import Pill from "../../../../shared/Pill/Pill";

const SalesPills = props => {
	const handleClick = programId => {
		if (props.isDisabled) {
			return;
		}

		return props.handleClick({ programId }, true);
	};

	const renderPills = () => {
		return props.excludeAvianca
			? props.programs.filter(program => program.id != 6).map(program => (
				<Pill
					className={`sales-pills--pill${props.selectedProgramId === program.id ? " sales-pills--pill--selected" : ""
						}`}
					onClick={e => handleClick(program.id)}
					key={program.id}
					selected={props.selectedProgramId === program.id}
					data-action="sales-pills-fidelity"
					isDisabled={props.isDisabled}
				>
					<strong>{program.name}</strong> - {program.company}
				</Pill>
			))
			: props.programs.map(program => (
				<Pill
					className={`sales-pills--pill${props.selectedProgramId === program.id ? " sales-pills--pill--selected" : ""
						}`}
					onClick={e => handleClick(program.id)}
					key={program.id}
					selected={props.selectedProgramId === program.id}
					data-action="sales-pills-fidelity"
					isDisabled={props.isDisabled}
				>
					<strong>{program.name}</strong> - {program.company}
				</Pill>
			));
	};

	return <div className="sales-pills">{renderPills()}</div>;
};

export default SalesPills;
